module.exports = __webpack_public_path__ + "static/img/zfb.095ae5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb.jpg
// module id = mwvW
// module chunks = 27